<template>
  <div
    class="overflow-menu"
    v-if="tagList.length > 0"
  >
    <a
      v-for="tag in tagList"
      :key="tag"
      class="tag"
    >#<span>{{tag}}</span></a>

  </div>
</template>

<script>
export default {
  props: {
    tags: { type: String, default: '' }
  },
  data () {
    return {
      tagList: (this.tags && this.tags.split(',')) || []
    }
  },
  watch: {
    tags () {
      this.tagList = (this.tags && this.tags.split(',')) || []
    }
  }
}
</script>
